import { companyRoutes, productRoutes, resourcesRoutes } from '@/utils/navigation';

/**
 * Retrieves the footer routes based on the device type (mobile or desktop).
 * @param isMobile A boolean indicating whether the device is mobile or not.
 * @returns An array of objects containing the title and routes for the footer navigation.
 */
export const getFooterRoutes = (isMobile: boolean) => {
  return isMobile ? [
    { title: "Company", routes: companyRoutes },
    { title: "Resources", routes: resourcesRoutes },
    { title: "Product", routes: productRoutes },
  ] : [
    { title: "Company", routes: companyRoutes },
    { title: "Product", routes: productRoutes },
    { title: "Resources", routes: resourcesRoutes },
  ];
}